import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { getApiBaseUrl } from "@/api/service.js";
import dayjs from "dayjs";
import util from "@/libs/util.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "quarter-statistics",
  data: function data() {
    return {
      date: [dayjs().subtract(7, 'day').startOf('day').toDate(), dayjs().subtract(1, 'day').endOf('day').toDate()],
      // 日期
      searchForm: {
        pageNum: 1,
        pageSize: 20,
        from: '',
        to: '',
        userStatus: "",
        companyName: "",
        personCharge: "",
        city: "",
        phone: "",
        userName: "",
        sortName: "",
        desc: true
      },
      // 搜索表单

      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now() || time.getTime() < new Date('2024-08-30').getTime();
        },
        firstDayOfWeek: 1,
        shortcuts: [{
          text: '上周',
          onClick: function onClick(picker) {
            var end = dayjs().startOf('week').subtract(1, 'week'); // 上周的开始日期
            var start = end.startOf('week'); // 上周的开始日期
            picker.$emit('pick', [start.add(1, 'day').toDate(), end.endOf('week').add(1, 'day').toDate()]);
          }
        }, {
          text: '上个月',
          onClick: function onClick(picker) {
            var end = dayjs().subtract(1, 'month').endOf('month'); // 上个月的结束日期
            var start = dayjs().subtract(1, 'month').startOf('month'); // 上个月的开始日期
            picker.$emit('pick', [start.toDate(), end.toDate()]);
          }
        }, {
          text: '过去7天',
          onClick: function onClick(picker) {
            var end = dayjs().subtract(1, 'day').endOf('day').toDate();
            var start = dayjs().subtract(7, 'day').startOf('day').toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '过去30天',
          onClick: function onClick(picker) {
            var end = dayjs().subtract(1, 'day').endOf('day').toDate();
            var start = dayjs().subtract(30, 'day').startOf('day').toDate();
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 总数

      adminList: [],
      cityList: [],
      exportLoading: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getAdminList();
            _this.getCityList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    sortChange: function sortChange(row) {
      console.log(row);
      if (row.prop == "leaveTraceUserCount") {
        this.searchForm.sortName = 'leave_trace_user_count';
      }
      if (row.prop == "customerInitiativeInquiryCount") {
        this.searchForm.sortName = 'customer_initiative_inquiry_count';
      }
      if (row.prop == "incrFavoritesCount") {
        this.searchForm.sortName = 'incr_house_view_count';
      }
      if (row.order == "descending") {
        this.searchForm.desc = true;
      } else if (row.order == "ascending") {
        this.searchForm.desc = false;
      } else {
        this.searchForm.sortName = "";
        this.searchForm.desc = true;
      }
      this.getData();
    },
    goCompany: function goCompany(row) {
      window.open("#/quarter/company?company=".concat(row.company));
    },
    exportData: function exportData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var urlParams, url;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              // 对象生成url参数
              urlParams = new URLSearchParams();
              urlParams.append("from", _this2.searchForm.from);
              urlParams.append("to", _this2.searchForm.to);
              _this2.searchForm.userStatus && urlParams.append("userStatus", _this2.searchForm.userStatus);
              _this2.searchForm.companyName && urlParams.append("companyName", _this2.searchForm.companyName);
              _this2.searchForm.personCharge && urlParams.append("personCharge", _this2.searchForm.personCharge);
              _this2.searchForm.city && urlParams.append("city", _this2.searchForm.city);
              _this2.searchForm.phone && urlParams.append("phone", _this2.searchForm.phone);
              _this2.searchForm.userName && urlParams.append("userName", _this2.searchForm.userName);
              util.cookies.get("uuid") && urlParams.append("adminId", util.cookies.get("uuid"));
              url = "".concat(getApiBaseUrl(), "/api/v3/admin/report/export?").concat(urlParams.toString());
              location.href = url;
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getCityList: function getCityList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$api.getCityListByPy();
            case 1:
              res = _context3.v;
              _this3.cityList = res.data;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getAdminList: function getAdminList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this4.$api.getAdminUser({
                type: "operate"
              });
            case 1:
              res = _context4.v;
              _this4.adminList = res.data;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    resetForm: function resetForm() {
      this.date = [dayjs().subtract(7, 'day').startOf('day').toDate(), dayjs().subtract(1, 'day').endOf('day').toDate()];
      this.searchForm = {
        pageNum: 1,
        pageSize: 20
      };
      this.getData('search');
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pageNum = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (type === "search") {
                _this5.searchForm.pageNum = 1;
              }
              if (_this5.date && _this5.date.length > 1) {
                _this5.searchForm.from = parseInt(_this5.date[0] / 1000);
                _this5.searchForm.to = parseInt(_this5.date[1] / 1000);
                if (_this5.date[0] === _this5.date[1]) {
                  _this5.searchForm.to = parseInt(_this5.date[1] / 1000) + 86400 - 1;
                }
              }
              _this5.tableLoading = true;
              _context5.n = 1;
              return _this5.$api.getQuarterUserReportList(_this5.searchForm);
            case 1:
              res = _context5.v;
              res.data.content.forEach(function (item) {
                item.user = {
                  id: item.user.id,
                  avatar: item.user.avatar,
                  phone: item.user.phone,
                  name: item.user.name,
                  remark: item.user.remark,
                  disable_send_msg_at: item.user.disableSendMsgAt,
                  user_type: item.user.userType,
                  user_type_status: item.user.userTypeStatus,
                  user_type_account_status: item.user.userTypeAccountStatus,
                  landlord_status: item.user.landlordStatus,
                  tenant_status: item.user.tenantStatus,
                  scene: item.user.scene
                };
              });
              _this5.tableData = res.data.content;
              _this5.total = res.data.totalCount;
              _this5.tableLoading = false;
              _this5.tableData.forEach(function (item) {
                return item.userId = item.user.id;
              });
              _this5.getUserListByIds(_this5.tableData, "userId");
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    }
  }
};